import { useMutation } from "@tanstack/react-query";
import {
  DeferReplacementRequestBody,
  updateAssetReplacementRequest,
  UpdateReplacementRequestBody,
} from "../../../resource/bff";

export const UseUpdateReplacementRequest = () => {
  const { isLoading, isError, isSuccess, mutate, status, variables } =
    useMutation({
      mutationFn: (
        param: UpdateReplacementRequestBody | DeferReplacementRequestBody
      ) => updateAssetReplacementRequest(param),
    });

  return {
    mutate,
    isSuccess,
    isError,
    isLoading,
    status,
  };
};
